import get from 'transmute/get';
export const getLabel = get('label');
export const getFullyQualifiedName = get('fullyQualifiedName');